import React from 'react';
import {
  Box,
  Container,
  Divider,
  makeStyles,
  Typography,
} from '@material-ui/core';
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import {
  AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE,
  AFFILIATED_LEAD_GENERATED_MODULE_ROUTE,
  AFFILIATED_MESSAGE_MODULE_ROUTE,
  AFFILIATED_ROUTE_PREFIX,
} from '../../routes/routes';
import SideNavBar from './SideNavBar';
import GeneratedLeads from './GeneratedLeads';
import ConvertedLeads from './ConvertedLeads';
import SendMessage from './SendMessage';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

function AffiliatedMarketing() {
  const classes = useStyles();

  return (
    <Container className={classes.overAll}>
      <Box display="flex" flex={1} justifyContent="center" alignItems="center">
        <Box flex={1} flexGrow={1}>
          <Typography variant="h4" component="div">
            <Box fontWeight="fontWeightMedium">Affiliate Marketing</Box>
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Managing Affiliate Marketing
          </Typography>
        </Box>
      </Box>
      <Divider />
      <Box display="flex" flex={10}>
        <Box minWidth={300} pt={4}>
          <SideNavBar />
        </Box>
        <Box flex={9} pt={4}>
          <Switch>
            <PrivateRoute
              exact
              path={[
                AFFILIATED_ROUTE_PREFIX,
                AFFILIATED_LEAD_GENERATED_MODULE_ROUTE,
              ]}
              component={GeneratedLeads}
            />
            <PrivateRoute
              exact
              path={[
                AFFILIATED_ROUTE_PREFIX,
                AFFILIATED_LEAD_CONVERTED_MODULE_ROUTE,
              ]}
              component={ConvertedLeads}
            />
            <PrivateRoute
              exact
              path={[AFFILIATED_ROUTE_PREFIX, AFFILIATED_MESSAGE_MODULE_ROUTE]}
              component={SendMessage}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
}

export default AffiliatedMarketing;
